import React, { useEffect, useState } from "react"

import Component from "./Component"

export default function Dropdown({
  children,
  className = "",
  nostyle = false,
  title,
  right = false,
  left = false,
  show,
  ...props
}) {
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    if (show !== undefined) setIsActive(show)
  }, [show])

  function showDropdown() {
    if (show === undefined) setIsActive(true)
  }
  function hideDropdown() {
    if (show === undefined) setIsActive(false)
  }

  let classes = {
    container: className,
    title: "link cursor-pointer ",
    menuContainer: "dropdown-menu-container absolute font-normal ",
    menu:
      "dropdown-menu bg-superdark text-light border border-dark shadow-lg rounded p-8 pb-4 ",
  }

  classes.container += " dropdown-container whitespace-no-wrap relative flex "
  if (nostyle) classes.title += "no-style "

  if (right) classes.menuContainer += "right-0 "
  else classes.menuContainer += "left-0 "

  return (
    <div
      className={`${classes.container} ${isActive ? "is-active" : ""}`}
      {...props}
      onMouseEnter={showDropdown}
      onMouseLeave={hideDropdown}
    >
      <span className={classes.title}>{title}</span>
      <div className={classes.menuContainer}>
        <div className={classes.menu}>{children}</div>
      </div>
    </div>
  )
}

export const DropdownHeader = Component({
  className: "text-subtle text-xs mb-2 uppercase",
})
export const DropdownItem = Component({ className: "mb-4 text-sm" })
export const DropdownDivider = () =>
  Component({ className: "mb-4" })({ children: <hr /> })
